import { Theme } from "apps/website/maps/Theme.map";
import { Size } from "apps/website/components/layout/Spacer/Spacer.map";

export const getSectionSize = (theme: Theme): Size | undefined => (theme === "default" ? "none" : undefined);
